<div class="auth-main particles_js">
    <div class="auth_div vivify popIn">
        <div class="auth_brand">
        </div>
        <div class="card">
            <div class="body" style="">
              <img src="" width="100" height="100%" class="d-inline-block align-top mr-2" alt="">
       

                <br>
              <div class=""><p class="lead">Recuperar Contraseña</p></div>

                        <div class="alert alert-primary" *ngIf="status == 'success'">
                            {{message}}
                        </div>
                    
                        <div class="alert alert-danger" *ngIf="status == 'error'">                            
                            {{message}}
                        </div>
                   

                    <form #cambiarForm="ngForm" (ngSubmit)="onSubmit(cambiarForm)" class="form-auth-small m-t-20">

                        <div class="form-group row">
                            <label for="email" class="col-md-12 col-form-label text-md-left">E-mail</label>

                            <div class="col-md-12">
                                <input type="email" class="form-control round" #email="ngModel" [(ngModel)]="user.email" name="email" placeholder="Email" required 
                                [ngClass]="{'is-invalid' : status == 'error'}">                                
                                <span *ngIf="!email.valid && email.touched">
                                    El email no es válido
                                </span>
                               
                            </div>
                        </div>

                        <div class="form-group row mb-0">
                            <div class="col-md-12 offset-md-12">
                                <button type="submit" class="btn btn-primary  btn-round btn-block" [disabled]="!cambiarForm.form.valid">
                                    <i class="fa " aria-hidden="true" [ngClass]="{ 'fa-paper-plane':!loading, ' fa-refresh fa-spin':loading }"></i>
                                        Recuperar Contraseña
                                    </button>
                            </div>
                        </div>
                    </form>






            </div>
        </div>
    </div>
    <div id="particles-js"></div>
</div>